// constants
import { showSuccessAlert } from "../../constants/alerts";
import { CategoryActionTypes } from "./constants";

const INIT_STATE = {
  category: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface categoryData {
  id: number;
  name: string;
}

interface CategoryActionType {
  type:
    | CategoryActionTypes.API_RESPONSE_SUCCESS
    | CategoryActionTypes.API_RESPONSE_ERROR
    | CategoryActionTypes.CREATE_CATEGORY
    | CategoryActionTypes.UPDATE_CATEGORY
    | CategoryActionTypes.GET_CATEGORY
    | CategoryActionTypes.DELETE_CATEGORY;
  payload: {
    actionType?: string;
    data?: categoryData | {};
    error?: string;
    category?: [];
  };
}

interface State {
  category?: categoryData[] | [];
  loading?: boolean;
  value?: boolean;
}

const CategoryStates = (
  state: State = INIT_STATE,
  action: CategoryActionType
): any => {
  switch (action.type) {
    case CategoryActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case CategoryActionTypes.CREATE_CATEGORY: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CategoryActionTypes.GET_CATEGORY: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            category: action.payload.data,
          };
        }
        case CategoryActionTypes.UPDATE_CATEGORY: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CategoryActionTypes.DELETE_CATEGORY: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case CategoryActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case CategoryActionTypes.CREATE_CATEGORY: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case CategoryActionTypes.UPDATE_CATEGORY: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case CategoryActionTypes.GET_CATEGORY: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case CategoryActionTypes.DELETE_CATEGORY: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case CategoryActionTypes.CREATE_CATEGORY:
      return { ...state, loading: true };
    case CategoryActionTypes.UPDATE_CATEGORY:
      return { ...state, loading: true };
    case CategoryActionTypes.GET_CATEGORY:
      return { ...state, loading: true, initialLoading: true };
    case CategoryActionTypes.DELETE_CATEGORY:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default CategoryStates;
